const initExhibitorResources = () => {
	const exhibitorResources = document.querySelector('.act-exhibitor-resources');
	if ( !exhibitorResources ) return;

	exhibitorResources.querySelectorAll('.top .button[href="#"]')
		.forEach((btn) => {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				exhibitorResources.querySelectorAll('.resource.active')
					.forEach((resource) => {
						resource.classList.remove('active');
					});
				this.closest('.resource').classList.add('active');
			});
		});
}

document.addEventListener("DOMContentLoaded", initExhibitorResources);